import { render } from "./TopView.vue?vue&type=template&id=458f5de7&scoped=true&ts=true"
import script from "./TopView.vue?vue&type=script&lang=ts"
export * from "./TopView.vue?vue&type=script&lang=ts"

import "./TopView.vue?vue&type=style&index=0&id=458f5de7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458f5de7"]])

export default __exports__